// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aIgv","badges":"styles_badges__SSRkq"};